import './InviteEducationSidebar.scss';

import { FamilyTreeDiagram } from '@pages/fvt/components/FamilyTreeDiagram';

const SPECIAL_SITUATIONS = [
  {
    lead: 'Half-siblings',
    body: 'Eligible as a separate relationship option. Invite them one at a time from this form.',
  },
  {
    lead: 'Spouses, step siblings, and step-parents',
    body: "No shared DNA. They're not eligible to participate, but you can still tell them.",
  },
  {
    lead: 'Adopted relatives',
    body: "If you don't share biology, don't invite them.",
  },
] as const;

export const InviteEducationSidebar = () => (
  <aside className='fvt-invite-edu' aria-label='Invitation guidance'>
    <p className='fvt-invite-edu__intro'>
      You send one invitation at a time. After each send, you can come back here to invite another eligible relative.
    </p>

    <FamilyTreeDiagram />

    <div className='fvt-invite-edu__card'>
      <h2 className='fvt-invite-edu__title'>Special situations</h2>
      <ul className='fvt-invite-edu__list'>
        {SPECIAL_SITUATIONS.map(item => (
          <li key={item.lead}>
            <strong>{item.lead}</strong>
            {item.body}
          </li>
        ))}
      </ul>
    </div>

    <div className='fvt-invite-edu__card'>
      <h2 className='fvt-invite-edu__title'>What we email them</h2>
      <p className='fvt-invite-edu__sub'>A short, plain-English message — no medical details, not your name.</p>
      <div className='fvt-invite-edu__email-preview'>
        <div className='fvt-invite-edu__email-subject'>
          Subject: A close family member shared a genetic testing opportunity with you
        </div>
        <p className='mb-0'>
          A close family member has been tested and may qualify you for no-charge genetic testing through MyOme. Click
          below to learn more or decline. The choice is entirely yours.
        </p>
      </div>
    </div>
  </aside>
);
